import getVideoId from "get-video-id";
import React, { useState } from "react";
import Loader from "react-loaders";
import Youtube from "react-youtube";

import styles from "./VideoBlock.module.scss";

interface Props {
  src: string;
}

export const VideoBlock: React.NamedExoticComponent<Props> = React.memo(
  ({ src }) => {
    const [isLoading, setIsLoading] = useState(true);

    const endLoading = () => setIsLoading(false);

    const { id: videoId } = getVideoId(src);

    if (!videoId) {
      return null;
    }

    return (
      <div className={styles.neutralize}>
        <div className={styles.video}>
          {isLoading && (
            <div className={styles.iframe}>
              <Loader active type="ball-scale-multiple" />
            </div>
          )}

          <Youtube
            className={styles.iframe}
            onError={endLoading}
            onReady={endLoading}
            opts={{
              playerVars: {
                controls: 0,
                disablekb: 0,
                modestbranding: 1,
                playsinline: 0,
                rel: 0,
                showinfo: 0,
              },
            }}
            videoId={videoId}
          />
        </div>
      </div>
    );
  },
);
